var quarterSelectInit = function() {
  jQuery('form.js-quarter-select').each((index, el) =>
    jQuery(el, 'select').on('change', () => {
      jQuery(el).submit();
    })
  );
};

$(document).on('turbolinks:load', quarterSelectInit);
